import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { useStyles } from "../ThemeModal/styles/index.styles";
import { useTranslation } from "react-i18next";
import { useModal } from "../../../hooks/useModal";

import FormCourse from "../../../../courses/components/FormCourse";

export function CourseModal() {
  const classes = useStyles();

  const { t } = useTranslation();

  const { dataModal, onCloseModalReset } = useModal();

  useEffect(() => {
    if (dataModal.loadingBtnClosed) {
      onCloseModalReset();
    }
  }, [dataModal.btnCloseModalClicked]);

  return (
    <Box className={classes.containerBody}>
      <FormCourse />
    </Box>
  );
}
